import React from "react";
import Modal from "../../../containers/Modal";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
import DynamicInput, {Label} from "../../../components/forms/DynamicInput";
import {simpleDate} from "../../../hooks/helpers";
// import {ReactComponent as CancelIcon} from "../../../assets/icons/cancel.svg";

export default function ShowApplicantModal({isOpen, close, theme, data}) {
   if (!data) return null;
   return (
      <Modal
         isOpen={isOpen}
         close={() => {
            close();
         }}
         // confirm={true}
         size="big"
         theme={theme}
         title="información del solicitante"
      >
         <DivModal>
            <div>
               <Grid>
                  <Col large="4">
                     <Label className="textModal">Nombre:</Label>
                     <DynamicInput className="readGhost" value={data.name} readOnly={true} placeholder="Nombre" name="name" />
                  </Col>
                  {/* <Col large="4" /> */}
                  <Col large="4">
                     <Label className="textModal">Email:</Label>
                     <DynamicInput className="readGhost" value={data.email} readOnly={true} placeholder="Area" name="area" />
                  </Col>
                  {/* <Col large="2" /> */}
                  <Col large="2">
                     <Label className="textModal">Teléfono:</Label>
                     <DynamicInput className="readGhost" value={data.phone} readOnly={true} placeholder="E-Mail" name="email" />
                  </Col>
                  <Col large="2">
                     <Label className="textModal">Fecha:</Label>
                     <DynamicInput
                        className="readGhost"
                        value={simpleDate(data.date)}
                        readOnly={true}
                        placeholder="Contraseña"
                        name="password"
                     />
                  </Col>
                  <Col large="4" className="maxMargin">
                     <Label className="textModal">Empresa:</Label>
                     <Label className="">{data.company}</Label>
                  </Col>
                  <Col large="6" className="maxMargin">
                     <Label className="textModal">Interés:</Label>
                     <Label className="">{data.subject}</Label>
                  </Col>
               </Grid>
            </div>
         </DivModal>
      </Modal>
   );
}

const DivModal = styled.div`
   .buttonModal {
      margin-top: 2em;
   }
   .maxMargin {
      margin-top: 2em;
   }
   .textModal {
      margin-bottom: 0.5em;
   }
`;
